var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueskyBrandsSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.8,358.7c-3.3-0.4-6.7-0.8-10-1.3C433.2,357.8,436.5,358.3,439.8,358.7z M320,291.1 c-26.1-50.7-97.1-145.2-163.1-191.8c-63.3-44.7-87.4-37-103.3-29.8C35.3,77.8,32,105.9,32,122.4S41.1,258,47,277.9 c19.5,65.7,89.1,87.9,153.2,80.7c3.3-0.5,6.6-0.9,10-1.4c-3.3,0.5-6.6,1-10,1.4c-93.9,14-177.3,48.2-67.9,169.9 C252.6,653.1,297.1,501.8,320,425.1c22.9,76.7,49.2,222.5,185.6,103.4c102.4-103.4,28.1-156-65.8-169.9c-3.3-0.4-6.7-0.8-10-1.3 c3.4,0.4,6.7,0.9,10,1.3c64.1,7.1,133.6-15.1,153.2-80.7c5.9-19.9,15-138.9,15-155.5s-3.3-44.7-21.6-52.9 c-15.8-7.1-40-14.9-103.2,29.8C417.1,145.9,346.1,240.4,320,291.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueskyBrandsSolidFull);
export default __webpack_public_path__ + "static/media/bluesky-brands-solid-full.2e4c8313e514baa77a0589e279dd6c58.svg";
export { ForwardRef as ReactComponent };